var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseIcon } from '@marketing/components/global/Icons';
import { clsx } from 'clsx';
import React, { useEffect, useRef } from 'react';
var getStyles = function (isFullScreenOnMobile, isModalOnTablet, isOpen) {
    var styles = [
        'bg-bone shadow-lg z-[52] transform transition-transform duration-1000 ease-in-out fixed',
    ];
    var mobileDrawerPositionStyles = 'left-0 bottom-0 rounded-t-lg w-full';
    var mobileDrawerAnimationStyles = isOpen ? 'translate-y-0' : 'translate-y-full';
    var mobileDrawerOverrideStyles = 'md:left-auto md:bottom-auto md:rounded-none';
    var mobileDrawerStyles = [mobileDrawerPositionStyles, mobileDrawerAnimationStyles];
    var mobileFullWidthPositionStyles = 'top-0 right-0 h-full w-full';
    var mobileFullWidthAnimationStyles = isOpen ? 'translate-x-0' : 'translate-x-full';
    var mobileFullWidthOverrideStyles = 'md:translate-x-0';
    var mobileFullWidthStyles = [
        mobileFullWidthPositionStyles,
        mobileFullWidthAnimationStyles,
        mobileFullWidthOverrideStyles,
    ];
    var tabletModalPositionStyles = 'md:left-0 md:right-0 md:top-0 md:bottom-0 md:m-auto md:rounded-lg md:max-w-[600px] md:h-fit';
    var tabletModalAnimationStyles = isOpen ? 'md:translate-y-0' : 'md:translate-y-[300%]';
    var tabletModalStyles = [tabletModalPositionStyles, tabletModalAnimationStyles];
    var tabletDrawerPositionStyles = 'md:top-0 md:right-0 md:h-full md:w-[424px] md:rounded-l-lg';
    var tabletDrawerAnimationStyles = isOpen
        ? 'md:translate-x-0'
        : 'md:translate-y-0 md:translate-x-full';
    var tabletDrawerStyles = [
        tabletDrawerPositionStyles,
        tabletDrawerAnimationStyles,
        mobileDrawerOverrideStyles,
    ];
    var mobileStyles = isFullScreenOnMobile ? mobileFullWidthStyles : mobileDrawerStyles;
    var tabletStyles = isModalOnTablet ? tabletModalStyles : tabletDrawerStyles;
    return clsx(styles, mobileStyles, tabletStyles);
};
var FlyoutContentWrapper = React.memo(function (_a) {
    var children = _a.children, isModalOnTablet = _a.isModalOnTablet, isFullScreenOnMobile = _a.isFullScreenOnMobile;
    if (isModalOnTablet) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsx("div", __assign({ className: clsx('h-full flex flex-col', !isFullScreenOnMobile && 'max-h-[calc(100vh-1px)]') }, { children: _jsx("div", __assign({ className: "flex-1 overflow-y-auto" }, { children: children })) })));
});
var Flyout = function (_a) {
    var children = _a.children, controlledIsOpen = _a.isOpen, onToggle = _a.onToggle, _b = _a.isFullScreenOnMobile, fullScreenOnMobile = _b === void 0 ? true : _b, modalOnTablet = _a.isModalOnTablet;
    var scrollContainerRef = useRef(null);
    useEffect(function () {
        if (controlledIsOpen) {
            document.body.classList.add('overflow-hidden');
        }
        else {
            document.body.classList.remove('overflow-hidden');
        }
        if (scrollContainerRef.current && controlledIsOpen) {
            scrollContainerRef.current.scrollIntoView({ behavior: 'instant' });
        }
        // Clean up when component unmounts
        return function () { return document.body.classList.remove('overflow-hidden'); };
    }, [controlledIsOpen]);
    return (_jsxs("div", { children: [controlledIsOpen && (_jsx("div", { className: "fixed inset-0 bg-shoe bg-opacity-50 z-[51]", onClick: onToggle })), _jsxs("div", __assign({ className: getStyles(fullScreenOnMobile, modalOnTablet, controlledIsOpen) }, { children: [_jsx("div", { children: _jsx("button", __assign({ onClick: onToggle, className: "absolute top-5 right-5 md:top-12 md:right-12" }, { children: _jsx(CloseIcon, { className: "text-icon-dark" }) })) }), _jsx(FlyoutContentWrapper, __assign({ isModalOnTablet: modalOnTablet, isFullScreenOnMobile: fullScreenOnMobile }, { children: _jsx("div", __assign({ ref: scrollContainerRef }, { children: children })) }))] }))] }));
};
export default Flyout;
